import { simpleSet } from '@r/reducers/utils';

const setLockViewMode = simpleSet as redux.reducers.flags.lockViewMode;
export const lockViewMode = setLockViewMode(
  'SET_LOCK_VIEW_MODE',
  false
);
